import rpcShared from '@rockpapercoin/rpc-shared';

export const enforceNoNonAlphaNumericMaxLength = (
	fieldName: string,
	value?: string | null
) => {
	if ( value ) {
		if (
			/\p{Extended_Pictographic}/u.test( value ) ||
			rpcShared.regex.nonAlphaNumeric.test( value ) ||
			rpcShared.regex.htmlTags.test( value )
		) {
			return rpcShared.strings.errorMessages.noNonAlphanumericCharacters(
				fieldName
			);
		}
		if ( value.length > 100 ) {
			return rpcShared.strings.errorMessages.fieldMaxLength( fieldName );
		}
	}
};
